import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
`;

export const Label = styled.label`
  display: flex;
  width: fit-content;
  gap: 5px;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const TextArea = styled.textarea<{ error?: boolean }>`
  width: 100%;
  height: 100px;
  border: 0;
  padding: 10px;
  font-size: 14px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => lighten(0.025, theme.colors.background)};
  color: ${({ theme }) => theme.colors.textBackground};
  resize: none;

  ${({ theme, error }) => error && `border: 2px solid ${theme.colors.error};`}

  &:focus {
    outline: none;
    background-color: ${({ theme }) => lighten(0.1, theme.colors.background)};
  }
`;

export const Counter = styled.span`
  width: fit-content;
  align-self: flex-end;
  font-size: 10px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const Legend = styled.span`
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.error};
`;
